import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import BooksCreateUserAlert from '../../../../components/books/model1/texts/BooksCreateUserAlert';
import BooksLoginRequireAlert from '../../../../components/books/model1/texts/BooksLoginRequireAlert';
import {
  UserContextConsumer,
  UserContextState,
} from '../../../../contexts/UserContext';
import {
  CreateUserQuery,
  LoginQuery,
  LoginWithFbQuery,
} from '../../../../infrastructure/repositories/AuthRepository';
import * as IInputs from '../../../../interfaces/merchants/resources/books/inputs';
import {
  setMeToBookInfo,
  setPostable,
} from '../../../../redux/actions/merchants/resources/books';
import { Dispatch } from '../../../../redux/reducers/merchants/resources/books/inputs';
import InputCreateUser from './InputCreateUser';
import InputLogin from './InputLogin';

interface ElementProps {
  postable: boolean;
  onSubmit: () => void;
  onRestart: () => void;
  renew?: boolean;
}

interface StateProps {
  inputs: IInputs.State;
}

interface DispatchProps {
  actions: {
    handleSetMe: (merchantId: string, resourceId: string) => Promise<void>;
    handlePostable: (postable: boolean) => void;
  };
}

enum ViewType {
  Login = 'login',
  CreateUser = 'createUser',
}

type Props = ElementProps & StateProps & DispatchProps & InjectedIntlProps;

interface State {
  viewType: ViewType;
}

class InputRequireLogin extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleCreateUser = this.handleCreateUser.bind(this);
    this.handleSwitchView = this.handleSwitchView.bind(this);
    this.state = {
      viewType: ViewType.Login,
    };
  }

  private handleSwitchView(viewType: ViewType) {
    this.setState({ viewType });
  }

  private async handleLogin(_q: LoginQuery, userCtx: UserContextState) {
    const { inputs, actions } = this.props;
    actions.handlePostable(false);
    userCtx.auth
      .login(_q.email, _q.password)
      .then(async _ => {
        await actions.handleSetMe(inputs.merchantId!, inputs.resourceId!);
        this.props.onSubmit();
        actions.handlePostable(true);
      })
      .catch((_err: Error) => {
        actions.handlePostable(true);
      });
  }

  private async handleLoginWithFb(
    query: LoginWithFbQuery,
    userCtx: UserContextState,
  ) {
    const { inputs, actions } = this.props;
    actions.handlePostable(false);
    userCtx.auth
      .loginWithFb(query)
      .then(async _ => {
        await actions.handleSetMe(inputs.merchantId!, inputs.resourceId!);
        this.props.onSubmit();
        actions.handlePostable(true);
      })
      .catch((_err: Error) => {
        actions.handlePostable(true);
      });
  }

  private async handleCreateUser(
    query: CreateUserQuery,
    userCtx: UserContextState,
  ) {
    const { inputs, actions } = this.props;
    actions.handlePostable(false);
    userCtx.auth
      .createUser(query)
      .then(async _ => {
        await actions.handleSetMe(inputs.merchantId!, inputs.resourceId!);
        this.props.onSubmit();
        actions.handlePostable(true);
      })
      .catch((_err: Error) => {
        actions.handlePostable(true);
      });
  }

  public render() {
    const { viewType } = this.state;
    const { postable } = this.props;
    return (
      <UserContextConsumer>
        {context => (
          <>
            {viewType === ViewType.Login && (
              <>
                <BooksLoginRequireAlert
                  onClick={() => this.handleSwitchView(ViewType.CreateUser)}
                />
                <InputLogin
                  postable={postable}
                  onLogin={(query: LoginQuery) =>
                    this.handleLogin(query, context)
                  }
                  onLoginWithFb={(query: LoginWithFbQuery) =>
                    this.handleLoginWithFb(query, context)
                  }
                  errors={context.auth.errors}
                />
              </>
            )}
            {viewType === ViewType.CreateUser && (
              <>
                <BooksCreateUserAlert
                  onClick={() => this.handleSwitchView(ViewType.Login)}
                />
                <InputCreateUser
                  postable={postable}
                  onSubmit={(query: CreateUserQuery) =>
                    this.handleCreateUser(query, context)
                  }
                  errors={context.auth.errors}
                />
              </>
            )}
          </>
        )}
      </UserContextConsumer>
    );
  }
}

const mapStateProps = ({
  merchantsResourcesBooksInputs,
}: {
  merchantsResourcesBooksInputs: IInputs.State;
}): StateProps => ({ inputs: merchantsResourcesBooksInputs });

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: {
    handleSetMe: (merchantId: string, resourceId: string) =>
      setMeToBookInfo(merchantId, resourceId)(dispatch),
    handlePostable: (postable: boolean) => setPostable(postable)(dispatch),
  },
});

export default connect(
  mapStateProps,
  mapDispatchToProps,
)(injectIntl(InputRequireLogin));
